uniform sampler2D uTexture;
uniform vec3 uColor;

void main() {
   float textureAlpha = texture(uTexture, gl_PointCoord).r;
    
   // Get hot white in the middle due to intense light
   float strength =  distance(gl_PointCoord, vec2(0.5));
   strength = 1.0 - strength;
   strength = pow(strength, 20.0);
   vec3 color = mix(uColor, vec3(1.0), strength);

   // Final color
   gl_FragColor = vec4(color, textureAlpha);
   #include <tonemapping_fragment>
   #include <colorspace_fragment>
}      